import React, { createContext, useState, useRef } from "react";

// Create two context:
// UserContext: to query the context state
// UserDispatchContext: to mutate the context state
const mapContext = createContext(undefined);

// A "provider" is used to encapsulate only the
// components that needs the state in this context
function MapProvider({ children }) {
	const mapContainer = useRef(null);
	const [map, setMap] = useState(null);
	const [mapLoaded, setMapLoaded] = useState(false);
	const [layersLoaded, setLayersLoaded] = useState(false);
	// const [mapBounds, setMapBounds] = useState(null);
	const [popupData, setPopupData] = useState(null);
	// const [count, setCount] = useState(0);
	// const [lngLat, setLngLat] = useState({ lng: null, lat: null });

	const Provider = mapContext.Provider;

	return (
		<Provider
			value={{
				mapContainer,
				map,
				setMap,
				mapLoaded,
				setMapLoaded,
				layersLoaded,
				setLayersLoaded,
				popupData,
				setPopupData
			}}
		>
			{children}
		</Provider>
	);
}

export { MapProvider, mapContext };
